export default "__VITE_ASSET__DSzlyiWa__"